import React, { useEffect, useRef, useState } from 'react'
import { getImages } from '../Common/const'

const PhotoUploadModal = ({ close, previewURL, files, setFiles }) => {
    const fileInputRef = useRef(null);
    console.log("files", files)
    useEffect(() => {
        if (previewURL && previewURL instanceof File) {
            const fileObj = {
                file: previewURL,
                name: previewURL.name,
                progress: 100, // assume already uploaded or set to 0
                id: Math.random().toString(36).substring(2, 9),
            };
            setFiles([fileObj]);
        }
        // Optional: if previewURL is already formatted, just do setFiles([previewURL])
    }, [previewURL]);
    const handleFiles = (newFiles) => {
        const fileArray = Array.from(newFiles).map((file) => ({
            file,
            name: file.name,
            progress: 0,
            id: Math.random().toString(36).substring(2, 9),
        }));

        const updatedFiles = [...files, ...fileArray];
        setFiles(updatedFiles);

        // Simulate upload
        fileArray.forEach((fileObj) => simulateUpload(fileObj.id));
    };

    const simulateUpload = (id) => {
        const interval = setInterval(() => {
            setFiles((prevFiles) =>
                prevFiles.map((f) =>
                    f.id === id
                        ? { ...f, progress: Math.min(f.progress + 10, 100) }
                        : f
                )
            );
        }, 200);

        setTimeout(() => clearInterval(interval), 2000); // Stop after 2 seconds
    };

    const handleDrop = (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
            handleFiles(e.dataTransfer.files);
            e.dataTransfer.clearData();
        }
    };

    const removeFile = (id) => {
        setFiles((prev) => prev.filter((file) => file.id !== id));
    };
    return (
        <>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title filter-modal-title">
                        Photo Upload
                    </h1>
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <div className="modal-body px-5 py-5">
                    <div 
                        className='photo-upload-dropzone'>
                        <div
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={handleDrop}
                            onClick={() => fileInputRef.current.click()}
                            style={{ cursor: 'pointer', padding: '20px', border: '2px dashed #ccc' }}
                        >
                            <img src={getImages('icon-upload.svg')} alt='upload' />
                            <div className='sm-title text-black opacity-0-5 text-center mt-3 mb-4'>
                                Drag and Drop your files or
                            </div>
                            <div className='text-center'>
                                <button
                                    type='button'
                                    className='black-btn w-50'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        fileInputRef.current.click();
                                    }}
                                >
                                    BROWSE
                                </button>
                            </div>
                            <div className='position-relative'>
                                <input
                                    type='file'
                                    multiple
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    onChange={(e) => handleFiles(e.target.files)}
                                />

                                <div className='file-list mt-4'>
                                    {files.length > 0 && (
                                        files.map((f) => (
                                            <div key={f.id} className='file-item mb-3 d-flex align-items-center justify-content-between gap-3'>
                                                <div className='flex-1 d-flex align-items-center'>
                                                    <div className='font-semibold text-sm truncate opacity-0-5'>{f.name}</div>
                                                    <div className="progress">
                                                        <div className="progress-bar" role="progressbar" aria-label="Basic example" style={{ width: `${f.progress}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                </div>
                                                <button
                                                    className='ms-3 text-red-500 text-lg file-close-btn'
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        removeFile(f.id);
                                                    }}
                                                >
                                                    ✖
                                                </button>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                        <button type='button' className='btn-theme lg-btn w-100 mt-3' onClick={close}>Done</button>
                </div>
            </div>
        </>
    )
}

export default PhotoUploadModal